module.exports = __webpack_public_path__ + "c055da435dd9d82bafde4fbf99507ccf.pdf";